import { Component, inject, OnInit } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { ModalComponent } from './modal.component';
import { defaultModalOptions, ModalContent, ModalInputs, ModalOptions } from './model';
import { ModalService } from './modal.service';
import { cloneDeep, merge } from 'lodash-es';

@Component({
  selector: 'app-modal-layout',
  imports: [NgComponentOutlet],
  templateUrl: './modal-layout.component.html',
  styles: `
    :host { display: contents; }
  `
})
export class ModalLayoutComponent implements OnInit {

  protected modalClass = ModalComponent
  protected modalsInputs: ModalInputs[] = []

  private modal = inject(ModalService)
  private id = 0

  ngOnInit(): void {
    this.modal.registerLayout(this)
  }

  create(content: ModalContent, options?: Partial<ModalOptions>) {
    this.id++
    this.modalsInputs.push({
      id: this.id,
      content: content,
      options: merge(cloneDeep(defaultModalOptions), options)
    })
    return this.id
  }

  destroy(id: number) {
    const i = this.modalsInputs.findIndex(m => m.id == id)
    if (i >= 0) {
      this.modalsInputs.splice(i, 1)
    }
  }

  protected getModalInputs(modalInputs: ModalInputs): Record<string, unknown> {
    return {...modalInputs} as Record<string, unknown>
  }

}
